import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { logout } from "../actions/userActions";
import Navbar from "../components/Navbar";
import Warning from "../components/Warning";
import MapDrag from "../components/MapDrag";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button, Row, Col, Image } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { listProducts } from "../actions/productActions";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "../components/Map.css";
import WarningCard from "../components/WarningCard";
// import * as FaIcons from "react-icons/fa";
const URL =
  process.env.NODE_ENV === "production" ? '' : "http://localhost:3001";
const DASHBOARD_VIEW_USER_KEY = "dashboardViewUserId";

const DashboardScreen = ({ match, history }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userIdParam = searchParams.get("userId");
  const [product, setProduct] = useState([]);
  const [viewingUser, setViewingUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(false);
  const [userError, setUserError] = useState(null);
  const [viewProducts, setViewProducts] = useState(null);
  const [latitude, setLatitude] = React.useState(13.067439);
  const [longitude, setLongitude] = React.useState(80.237617);
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const productList = useSelector((state) => state.productList);

  const { loading, error, products } = productList;
  const center = [latitude, longitude];

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    } else {
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const fetchProduct = async () => {
        const { data } = await axios.get(URL + `/api/products`, config);
        setProduct(data);
      };
      fetchProduct();
      dispatch(listProducts());
    }
  }, [match]);

  useEffect(() => {
    const stored = sessionStorage.getItem(DASHBOARD_VIEW_USER_KEY);
    if (
      location.pathname === "/dashboard" &&
      !userIdParam &&
      stored
    ) {
      history.replace(`/dashboard?userId=${stored}`);
      return;
    }
    if (userIdParam) {
      sessionStorage.setItem(DASHBOARD_VIEW_USER_KEY, userIdParam);
    }
    if (!userIdParam || !userInfo?.token) {
      setViewingUser(null);
      setViewProducts(null);
      setLoadingUser(false);
      setUserError(null);
      return;
    }
    setLoadingUser(true);
    setUserError(null);
    setViewProducts(null);
    const config = { headers: { Authorization: `Bearer ${userInfo.token}` } };
    Promise.all([
      axios.get(URL + `/api/users/${userIdParam}`, config),
      axios.get(URL + `/api/products?forUser=${userIdParam}`, config),
    ])
      .then(([userRes, productsRes]) => {
        setViewingUser(userRes.data);
        setViewProducts(Array.isArray(productsRes.data) ? productsRes.data : []);
        setUserError(null);
      })
      .catch((err) => {
        setViewingUser(null);
        setViewProducts([]);
        setUserError(err.response?.data?.message || "Failed to load user");
      })
      .finally(() => setLoadingUser(false));
  }, [userIdParam, userInfo?.token, location.pathname, history]);

  const displayProducts = useMemo(() => {
    if (userIdParam) {
      if (loadingUser || userError) return [];
      return viewProducts || [];
    }
    return products || [];
  }, [userIdParam, loadingUser, userError, viewProducts, products]);

  useEffect(() => {
    if (error) {
      dispatch(logout());
      history.push("/login");
    }
  }, [error])

  const logoutHandler = () => {
    dispatch(logout());
  };
  const exploreHandler = (id) => {
    if (products && products.length) {
      history.push(`/product/${id}`);
    }
  };
  return (
    <>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <br />
      <h1 className="tw-font-nunito tw-text-center sm:tw-text-3xl tw-text-xl">
        Welcome {userInfo?.username}!
      </h1>
      {userIdParam && (
        <>
          {loadingUser && <p className="tw-font-nunito tw-text-center">Loading user…</p>}
          {userError && (
            <p className="tw-font-nunito tw-text-center tw-text-red-600">{userError}</p>
          )}
          {viewingUser && !loadingUser && (
            <p className="tw-font-nunito tw-text-center tw-text-lg tw-text-gray-700">
              Viewing gensets for <strong>{viewingUser.username}</strong>
              {" · "}
              <Link
                to="/dashboard"
                onClick={() => sessionStorage.removeItem(DASHBOARD_VIEW_USER_KEY)}
              >
                Show all gensets
              </Link>
            </p>
          )}
        </>
      )}
      <br />
      <p className="tw-font-nunito  sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
        Genset Status
      </p>
      <br />
      <div className="tw-font-nunito tw-flex tw-flex-row tw-justify-evenly tw-flex-wrap">
        {displayProducts && displayProducts.map((product) => (
          <React.Fragment key={product.gensetNumber}>
            <WarningCard
              title={product.gensetNumber}
              productId={product._id}
              reading={product.getsetStatus}
              fuel={product.fuelLevel[product.fuelLevel.length - 1]}
              fuelMin={product.fuelLevelOffset.min}
              coolant={product.engineCoolantTemp[product.engineCoolantTemp.length - 1]}
              coolantMax={product.engineCoolantTempOffset.max}
              product={product}
            />
          </React.Fragment>
        ))}
      </div>
      <div className="container tw-font-nunito">
        <br />
        <br />
        <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
          Genset Location
        </p>
        <br />
        <div className="tw-flex tw-justify-around tw-flex-wrap map-container">
          {displayProducts && displayProducts.length > 0 && (
            <>
              <MapContainer center={center} zoom={5} scrollWheelZoom={true}>
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {displayProducts &&
                  displayProducts.map((product) => (
                    <Marker
                      position={{
                        lat: product.latitude,
                        lng: product.longitude,
                      }}
                      key={product.gensetNumber}
                    >
                      <Popup minWidth={90}>
                        Genset ID: {product.gensetNumber}
                        <br />
                        Latitude: {product.latitude} <br />
                        Longitude: {product.longitude}
                      </Popup>
                    </Marker>
                  ))}
              </MapContainer>
            </>
          )}
        </div>
        <br />
        <br />
        <p className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
          Genset Details
        </p>
        <br />
        <div className="tw-w-6/6">
          <Row className="align-items-center">
            <Col>
              <h5 className="tw-font-nunito tw-text-xl tw-font-semibold">
                Total Genset: {displayProducts && displayProducts.length}
              </h5>
              <br />
            </Col>
          </Row>
          {loading ? (
            <Loader />
          ) : error ? (
            <Message variant="danger">{error}</Message>
          ) : (
            <Table
              striped
              bordered
              hover
              responsive
              className="table-sm tw-text-center tw-font-nunito md:tw-text-lg tw-text-xs"
            >
              <thead
                className="tw-text-center tw-text-gray-100"
                style={{ backgroundColor: "#4a372e" }}
              >
                <tr>
                  <th>GENSET ID</th>
                  <th>STATUS</th>
                  <th>DUE DATE</th>
                  <th>EXPLORE</th>
                </tr>
              </thead>
              <tbody>
                {displayProducts &&
                  displayProducts.map((product) => (
                    <tr key={product._id}>
                      <td>{product.gensetNumber}</td>
                      <td>{product.getsetStatus}</td>
                      <td>{new Date(product.servicedueDate).toDateString()}</td>
                      <td>
                        <Button
                          variant="success"
                          className="btn-sm"
                          onClick={() => exploreHandler(product._id)}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
      <br />
      <br /> <br />
      <br />
    </>
  );
};

export default DashboardScreen;
